export const iconFontAwesomeHumanitarianWheatAwnCircleExclamation = (
	<i className="fa-solid fa-wheat-awn-circle-exclamation"></i>
);
